<template>
  <div class="case-view">
    <!-- Title -->
    <title-component :size="1">
      <translate>Case</translate>
      {{ kase.caseNumber }}
    </title-component>
    <grid-details-component
      v-if="kase.id"
      :display_spec="caseSpecs"
      :item="kase"
      :item_keys="case_keys">
    </grid-details-component>
    <!-- Message -->
    <message-component v-if="kase.result" :level="'success'">
      <link-component v-if="kase.certificate"
        :name="'ReportsUpcomingView'"
        :params="{ certificateId: kase.certificate.id }">
          <translate> {{ kase.result.comment }} </translate>
      </link-component>
      <translate v-else> {{ kase.result.comment }} </translate>
    </message-component>
    <!-- Application and documents information -->
    <title-component
      v-if="kase.customer"
      :size="2"
      :lineSeparator="'under'">
      <translate>Application</translate>
    </title-component>
    <grid-details-component
      v-if="documentsLoaded"
      :display_spec="caseSpecs"
      :item="kase"
      :item_keys="application_keys"
      :layoutClasses="getApplicationLayoutClasses()">
    </grid-details-component>
    <!-- Loader -->
    <loader-component v-else :position="'relative'"></loader-component>
    <!-- Customer and invoicing tabs -->
    <div class="tabs-container">
      <action-dropdown-component
        v-if="customerActions.length"
        :actions="customerActions"
        class="action-dropdown">
      </action-dropdown-component>
      <tabs-router-component :tabs="routes">
      </tabs-router-component>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { caseSpecs } from '@/display_context/display_context'
  import TitleComponent from '@/components/layout/TitleComponent'
  import GridDetailsComponent from '@/components/layout/grid/GridDetailsComponent'
  import { itemRefresher, setContainedHeightMixin } from '@/mixins/mixins'
  import ActionDropdownComponent from '@/components/layout/utility/ActionDropdownComponent.vue'
  import { updateArrayForValue, assignLayoutClasses } from '@/utility/utility_functions'
  import MessageComponent from '@/components/layout/utility/MessageComponent'
  import TabsRouterComponent from '@/components/layout/tabs/TabsRouterComponent.vue'
  import LinkComponent from '@/components/layout/utility/LinkComponent'
  import LoaderComponent from '@/components/layout/utility/LoaderComponent'

  export default {
    name: 'case-view',
    mixins: [setContainedHeightMixin, itemRefresher],
    data () {
      return {
        case_keys: ['stateCell', 'caseType.display', 'reviewer.name', 'responsible.profileTypeDisplay', 'modified', 'controller.name'],
        application_keys: ['created', 'service.code', 'qualification.display', 'documentsTable'],
        caseSpecs: caseSpecs,
        kase: {},
        setAction: this.setCase,
        customerActions: [],
        documentsLoaded: false,
        routes: [
          {
            route: { name: 'CaseView' },
            text: 'Customer'
          },
          {
            route: { name: 'CaseInvoiceView' },
            text: 'Invoices'
          }
        ]
      }
    },
    props: {
      caseId: {
        required: true
      }
    },
    components: {
      TitleComponent,
      GridDetailsComponent,
      ActionDropdownComponent,
      MessageComponent,
      TabsRouterComponent,
      LinkComponent,
      LoaderComponent
    },
    computed: {
      ...mapState({
        caseFiles: state => state.filesModule.files,
        cases: state => state.caseModule.cases
      })
    },
    methods: {
      ...mapActions([
        'setCase',
        'getFiles'
      ]),
      updateCaseKeys () {
        if (this.kase && this.kase.isAuditorRequested()) {
          updateArrayForValue(this.case_keys, { 'reviewer.name': 'requestedAuditor.name' })
        }
        if (this.kase && this.kase.isOvertakingCase()) {
          this.case_keys.push('currentCa')
          this.case_keys.push('currentCertificateNumber')
        }
      },
      setActions () {
        this.customerActions = []
        this.customerActions.push(
          {
            type: 'ROUTE',
            route: { name: 'InvoicingView' },
            text: 'View customer...'
          },
          {
            type: 'ROUTE',
            route: { name: 'CustomerEditView', params: { backlink: { name: 'CaseView', params: { caseId: this.caseId } } } },
            text: 'Edit customer...'
          }
        )
      },
      checkRedirect () {
        if (this.kase.isInReview()) {
          this.$router.replace({ name: 'CaseReviewFindingsView', params: { caseId: this.kase.id } })
        }
      },
      setDocumentsTable () {
        this.kase.documentsTable = {
          documents: this.caseFiles
        }
        this.documentsLoaded = true
      },
      getCaseFiles () {
        this.getFiles(this.caseId).then(() => {
          this.setDocumentsTable()
        }).catch((err) => {
          this.handleError(err)
        })
      },
      getApplicationLayoutClasses () {
        let values = {
          '3': 'is-12-mobile is-12-tablet is-12-desktop',
          'default': 'is-6-mobile is-4-tablet is-3-desktop'
        }
        return assignLayoutClasses(values, this.application_keys.length)
      }
    },
    created () {
      let callbacks = [this.updateCaseKeys, this.getCaseFiles, this.setActions, this.checkRedirect]
      this.setOrRefreshItem('kase', this.cases, this.caseId, callbacks)
    }
  }
</script>
<style lang="sass" scoped>
  .tabs-container
    position: relative
  .action-dropdown
    position: absolute
    padding-left: 1rem
    background: white
    right: 0
    top: 1rem
</style>
